import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full flex flex-row" }
const _hoisted_2 = { class: "col-3 bg-white p-3 border-round-2xl" }
const _hoisted_3 = { class: "list-none p-0" }
const _hoisted_4 = { class: "flex items-center border-bottom-2 border-100" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center border-bottom-2 border-100"
}
const _hoisted_6 = { class: "col-9 ml-4 pr-4" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

import { onMounted, onUnmounted, ref, computed } from 'vue';
import { SalesRep, MessageCenter } from '@/views/Admin/Tenants/components';
import { can, useTenant } from '@/composables';
import { PERMISSIONS, TENANT_SETTINGS } from '@/enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'Tools',
  setup(__props) {

const currentView = ref('salesreps');
const hasSalesRepsAccess = ref(false);
const $tenant = useTenant();

onMounted(() => {
  updateCurrentView();
  window.addEventListener('hashchange', updateCurrentView);
  if (can([PERMISSIONS.SALESREPS_INDEX])) {
    hasSalesRepsAccess.value = true;
  }
});

function updateCurrentView() {
  currentView.value = window.location.hash.replace('#', '') || 'salesreps';
}

onUnmounted(() => {
  window.removeEventListener('hashchange', updateCurrentView);
});

const isMessageCenterEnabled = computed(() => {
  return $tenant.tenantSettingEnabled(TENANT_SETTINGS.MESSAGE_CENTER);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("a", {
            class: _normalizeClass(["p-3 font-semibold no-underline", currentView.value === 'salesreps' ? 'text-color-green' : 'text-500']),
            href: "#salesreps"
          }, " Sales Reps List ", 2)
        ]),
        (isMessageCenterEnabled.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
              _createElementVNode("a", {
                class: _normalizeClass(["p-3 font-semibold no-underline", currentView.value === 'messagecenter' ? 'text-color-green' : 'text-500']),
                href: "#messagecenter"
              }, " Message Center ", 2)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (currentView.value === 'salesreps' && hasSalesRepsAccess.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_unref(SalesRep))
          ]))
        : (currentView.value === 'messagecenter')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_unref(MessageCenter))
            ]))
          : _createCommentVNode("", true)
    ])
  ]))
}
}

})